import { overrides as mediaLibraryWidgetDemoOverrides } from './media-library-widget-demo';

export const overrides = { mediaLibraryWidgetDemoOverrides };
